import { render, staticRenderFns } from "./InPractisePPP.vue?vue&type=template&id=08a4929c&"
import script from "./InPractisePPP.vue?vue&type=script&lang=ts&"
export * from "./InPractisePPP.vue?vue&type=script&lang=ts&"
import style0 from "./InPractisePPP.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports